import { style } from 'typestyle';
import {
    COLOR_12,
    COLOR_33,
    FONT_WEIGHT_BLACK,
    FONT_WEIGHT_BOLD,
    FONT_WEIGHT_MEDIUM,
    FONT_WEIGHT_REGULAR,
    MARGINS_PX
} from '../../../constants';
import { mixinFont } from '../../../style.mixin';
import { desktopStyles, styleOverride, tabletStyles } from '../../../utils';

export const globalQuotaTypeChartClassName = style({
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    flexWrap: 'nowrap'
});

export const globalQuotaTypeChartDonutClassName = style({
    flexGrow: 1,
    flexShrink: 0
});

export const globalQuotaTypeChartDonutContainerClassName = style({
    display: 'block',
    margin: '0 auto',
    maxWidth: '260px',
    fontSize: '92px',
    padding: `${MARGINS_PX}px 0`,
}, desktopStyles({
    maxWidth: '200px',
}));

export const globalQuotaTypeChartDoubleDonutContainerClassName = style({
    padding: `${MARGINS_PX}px`,
}, desktopStyles({
    maxWidth: '260px',
}));

export const globalQuotaTypeChartLabelNumberClassName = style({
    ...mixinFont('90%', FONT_WEIGHT_BLACK, '90%', COLOR_12)
});

export const globalQuotaTypeChartLabelTextClassName = style({
    ...mixinFont('13%', FONT_WEIGHT_MEDIUM, '100%', COLOR_12),
    textAlign: 'center'
});

// export const globalQuotaTypeChartCaptionClassName = style({
//     padding: `${MARGINS_PX}px 0 0 0`,
//     maxWidth: '140px',
//     margin: '0 auto'
// });

// export const globalQuotaTypeChartCaptionNumberClassName = style({
//     ...mixinFont(32, FONT_WEIGHT_BOLD, '115%')
// });

// export const globalQuotaTypeChartCaptionCircleClassName = style({
//     display: 'inline-block',
//     ...mixinSize(24),
//     backgroundColor: 'gainsboro',
//     borderRadius: '50%',
//     marginRight: '8px'
// });

// export const globalQuotaTypeChartCaptionTextClassName = style({
//     ...mixinFont('13%', FONT_WEIGHT_MEDIUM, '115%')
// });


export const globalQuotaTypeChartStatisticsColumn = style({
    display: 'block',
    padding: `${MARGINS_PX}px`
}, tabletStyles({
    padding: `${MARGINS_PX}px ${MARGINS_PX}px ${MARGINS_PX * 3}px ${MARGINS_PX}px`
}));

export const globalQuotaTypeChartStatisticsColumnTitle = style({
    ...mixinFont('19px', FONT_WEIGHT_BOLD),
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});

export const globalQuotaTypeChartStatisticsColumnItem = style({
    display: 'block',
    margin: `${MARGINS_PX}px 0`
});

export const globalQuotaTypeChartStatisticsColumnNumberClassName = style({
    ...mixinFont('27px', FONT_WEIGHT_BLACK, '27px'),
    display: 'block',
    float: 'left',
    textAlign: 'left',
    width: '40px',
    padding: '1px 0'
});

export const globalQuotaTypeChartStatisticsColumnName = style({
    ...mixinFont('12px', FONT_WEIGHT_REGULAR, '14px'),
    overflow: 'hidden'
});

export const globalQuotaTypeChartStatisticsColumnThemeGreenClassName = styleOverride(
    {
        backgroundColor: COLOR_33
    }
);

export const resetSpacingsClassName = style({
    margin: 0,
    padding: 0
});

// export const globalQuotaTypeLinkWrapperClassName = style({
//     textAlign: 'right',
//     padding: 0,
//     margin: `${MARGINS_PX * 2}px 0 0 0`,

//     $nest: {
//         'a': {
//             ...mixinFont(12, FONT_WEIGHT_BOLD),
//             textDecoration: 'none',
//             cursor: 'pointer'
//         },
//         'img': {
//             transform: 'rotate(90deg)',
//             marginLeft: '5px'
//         }
//     }
// });

export const parliamentAndLocalGovernmentLinksClassName = style({
    display: "block",
    textAlign: "left",
    ...mixinFont(12, FONT_WEIGHT_BOLD),

    $nest: {
        'a': {
            textDecoration: 'underline',
            color: COLOR_12,
            display: 'inline-block',
        },
    }
}, tabletStyles({
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
}));

export const quotaTypeChartStatisticsCaptionClassName = style({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
});

export const quotaTypeChartStatisticsCaptionNumberClassName = style({
    display: 'block',
    height: '30px',
    width: 'auto',
    margin: `0 ${MARGINS_PX / 4}px 0 0`,
    ...mixinFont('30px', FONT_WEIGHT_BOLD, '30px'),
});

export const quotaTypeChartStatisticsCaptionDescriptionClassName = style({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '30px',
    boxSizing: 'border-box',
    ...mixinFont('10px', FONT_WEIGHT_BOLD, '12px'),
    padding: `2px 0`,
});

export const quotaTypeChartStatisticsCaptionDescriptionSmallClassName = style({
    ...mixinFont('8px', FONT_WEIGHT_BOLD, 'auto'),
    margin: `${MARGINS_PX / 2}px 0 0 0`,
});
